var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('notifications',{attrs:{"position":"bottom right","classes":"my-notification"}}),(_vm.withLayout)?_c('AppLayout',[(_vm.hasProject)?_c('RouterView'):_vm._e()],1):_c('RouterView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }